export const splitIntoTwoColumns = <T extends unknown>(
  arr: T[]
): [T[], T[]] => {
  if (arr.length === 0) return [[], []];
  if (arr.length === 1) return [arr, []];
  const cutoff = arr.length % 2 === 0 ? arr.length / 2 : arr.length / 2 + 1;
  return [arr.slice(0, cutoff), arr.slice(cutoff)];
};
